var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"20px","width":"100%","height":"100%"}},[_c('el-empty',{staticStyle:{"width":"100%","height":"100%"},attrs:{"image-size":200,"description":"页面未找到，或者没有权限查看，请检查url或者联系管理员！"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }